import React, { useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';

import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import InterviewBlock from '../../empDashboardMyCalendar/subComponents/InterviewBlock';
import MoreInterviewsBlock from '../../empDashboardMyCalendar/subComponents/MoreInterviewsBlock';

import cx from 'clsx';
import _get from 'lodash/get';
import format from 'date-fns/format';
import startOfDay from 'date-fns/startOfDay';
import isEqual from 'date-fns/isEqual';

const styles = theme => ({
    root: {
        // minWidth: '100px',
        minHeight: '180px',
        flexGrow: 1,
        flexBasis: 0,
        borderRight: '1px solid #F0F0F0',
        '&:hover': {
            cursor: 'pointer',
        },
        [theme.breakpoints.up('lg')]: { minWidth: '100px' },
    },
    lastDayOfWeek: {
        borderRight: 'none',
    },
    dayLabelContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    dayLabel: {
        width: '28px',
        height: '28px',
        minWidth: '28px',
        lineHeight: '28px',
        color: '#111E14',
        fontWeight: 600,
        marginTop: '2px',
        marginRight: '2px',
    },
    today: {
        background: '#CDBFBF',
        color: '#FFFFFF',
        borderRadius: '14px',
    },
    selectedDay: {
        background: '#1D8A8B',
        color: '#FFFFFF',
        borderRadius: '14px',
    },
    inactiveDay: {
        color: 'rgba(17, 30, 20, 0.4)',
    },
    interviewsContainer: { display: 'flex', flexDirection: 'column' },
});

const getDefns = params => {
    const { props, id, day, selectedDate, setSelectedDate } = params;
    const {
        classes,
        classes: { root: rootCls, lastDayOfWeek: lastDayOfWeekCls, dayLabel: dayLabelCls, today: todayCls, selectedDay: selectedDayCls, inactiveDay: inactiveDayCls },
        interviewList = [],
    } = props;

    const active = _get(day, 'active');
    const dt = _get(day, 'dt');
    const today = startOfDay(new Date());
    const isLastDayOfWeek = _get(day, 'isLastDayOfWeek');
    const interviewListCount = interviewList.length;

    let rootClasses = [rootCls];
    if (isLastDayOfWeek) rootClasses.push(lastDayOfWeekCls);

    let dayLabelClasses = [dayLabelCls];
    if (!active) dayLabelClasses.push(inactiveDayCls);
    if (isEqual(dt, today)) dayLabelClasses.push(todayCls);
    if (isEqual(startOfDay(selectedDate), dt)) dayLabelClasses.push(selectedDayCls);

    let defns = {
        root: {
            onClick: handleClickRoot.bind(null, setSelectedDate.bind(null, dt)),
            className: cx(rootClasses), // condition inside classnames didn't work for some reasons... so did it outside
        },
        dayLabel: {
            className: cx(dayLabelClasses), // condition inside classnames didn't work for some reasons... so did it outside
        },
        interview: {
            isHidden: interviewListCount === 0,
            interviewData: _get(interviewList, '[0]'),
            dt,
        },
        interview2: {
            isHidden: interviewListCount < 2,
            interviewData: _get(interviewList, '[1]'),
            dt,
        },
        moreInterviewsBlock: {
            isHidden: interviewListCount < 3,
            remainingCount: interviewListCount - 2,
            interviewList,
            dt,
            dayId: id,
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

const handleClickRoot = (setSelectedDate, evt) => {
    evt.preventDefault();
    setSelectedDate();
};

const Day = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    const context = useContext(LayoutContext);
    const calendarData = _get(context, 'calendarData');
    const selectedDate = _get(context, 'selectedDate');
    const setSelectedDate = _get(context, 'setSelectedDate');
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    const id = _get(props, 'id');
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    const day = _get(calendarData, id);
    const dayLabel = format(_get(day, `dt`), 'd');
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    const defns = getDefns({
        props,
        id,
        day,
        dayLabel,
        selectedDate,
        setSelectedDate,
    });
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Render
    return (
        <div {...defns.root} id={id}>
            <div {...defns.dayLabelContainer}>
                <div {...defns.dayLabel}>{dayLabel}</div>
            </div>
            <div {...defns.interviewsContainer}>
                {!defns.interview.isHidden && <InterviewBlock {...defns.interview} />}
                {!defns.interview2.isHidden && <InterviewBlock {...defns.interview2} />}
                {!defns.moreInterviewsBlock.isHidden && <MoreInterviewsBlock {...defns.moreInterviewsBlock} />}
            </div>
        </div>
    );
    //---------------------------------------------------------------------
};

export default withStyles(styles)(Day);
